"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveFocusAndToggle = exports.maybeBackspaceIntoHeading = exports.ensureVisualAccordionImages = exports.pickBackgroundImage = exports.expandAccordionIfCollapsed = exports.quickCreateAccordion = exports.enterAtEndOfAccordionHeading = exports.accordionMatcher = exports.cloneAccordionWidget = exports.setExpanded = void 0;
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var Utils_1 = require("Project/QwilrEditor/Utils");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var Utils_2 = require("Project/QwilrEditor/Utils");
var lodash_1 = require("lodash");
var Text_1 = require("ContentTokens/Models/Text");
var ShowImagePicker_1 = __importDefault(require("Project/QwilrEditor/ShowImagePicker"));
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var PasteActions_1 = require("../PasteActions");
var Paragraph_1 = require("Project/QwilrEditor/WidgetRegistry/Widgets/Paragraph");
var setExpanded = function (editor, path, expanded) {
    var accordionWidget = (0, Utils_2.as)("accordion", slate_1.Node.descendant(editor, path));
    var nextData = (0, lodash_1.cloneDeep)(accordionWidget.data);
    nextData.expanded = expanded;
    slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
    var selection = editor.selection;
    if (selection) {
        var accordionBodyRange = slate_1.Editor.range(editor, __spreadArray(__spreadArray([], __read(path), false), [1], false));
        var selectionInBody = slate_1.Range.includes(accordionBodyRange, selection);
        if (selectionInBody) {
            slate_1.Transforms.select(editor, slate_1.Editor.end(editor, __spreadArray(__spreadArray([], __read(path), false), [0], false)));
        }
    }
    slate_react_1.ReactEditor.focus(editor);
};
exports.setExpanded = setExpanded;
var cloneAccordionWidget = function (editor, path) {
    var existingAccordion = (0, Utils_2.as)("accordion", slate_1.Node.descendant(editor, path));
    var newAccordion = (0, lodash_1.cloneDeep)(existingAccordion);
    slate_1.Transforms.insertNodes(editor, newAccordion, { at: slate_1.Path.next(path) });
    var nextTextEntry = (0, Utils_1.getNext)(editor, path, Text_1.Text.isText);
    if (!nextTextEntry) {
        return;
    }
    (0, lodash_1.defer)(function () {
        slate_1.Transforms.select(editor, { path: nextTextEntry[1], offset: 0 });
        slate_react_1.ReactEditor.focus(editor);
    });
};
exports.cloneAccordionWidget = cloneAccordionWidget;
var enterAtEndOfAccordionHeading = function (editor) {
    var anchor = editor.selection.anchor;
    var _a = __read((0, Utils_1.checkAncestors)(editor, anchor.path, accordionMatcher), 2), accordionPath = _a[1];
    var accordionHeadingEndPath = slate_1.Editor.range(editor, __spreadArray(__spreadArray([], __read(accordionPath), false), [0], false)).focus;
    if (!slate_1.Point.equals(anchor, accordionHeadingEndPath)) {
        return;
    }
    var accordionBodyStartPath = __spreadArray(__spreadArray([], __read(accordionPath), false), [1, 0], false);
    var _b = __read(slate_1.Editor.node(editor, accordionBodyStartPath), 1), accordionBodyFirstNode = _b[0];
    var firstNodeIsEmptyTextNode = slate_1.Element.isElement(accordionBodyFirstNode) &&
        ["heading1", "heading2", "paragraph"].includes(accordionBodyFirstNode.type) &&
        slate_1.Editor.string(editor, accordionBodyStartPath) === "";
    if (!firstNodeIsEmptyTextNode) {
        slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
            at: accordionBodyStartPath,
        });
    }
    slate_1.Transforms.select(editor, accordionBodyStartPath);
    return true;
};
exports.enterAtEndOfAccordionHeading = enterAtEndOfAccordionHeading;
var quickCreateAccordion = function (editor, blockStyleStore, stockImagesService) { return __awaiter(void 0, void 0, Promise, function () {
    var selection, _a, existingAccordionPath, existingAccordion, newAccordion, _b, _c, headingElement, headingTextNode, newAccordionPath, newAccordionHeadingPath;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                selection = editor.selection;
                _a = __read((0, Utils_1.checkAncestors)(editor, selection.anchor.path, accordionMatcher), 2), existingAccordionPath = _a[1];
                existingAccordion = (0, Utils_2.as)("accordion", slate_1.Node.descendant(editor, existingAccordionPath));
                newAccordion = (0, lodash_1.cloneDeep)(existingAccordion);
                newAccordion.data.expanded = false;
                _b = newAccordion.data;
                if (!isVisualAccordion(blockStyleStore)) return [3, 2];
                return [4, stockImagesService.getRandomImage({ preventBoringImages: true })];
            case 1:
                _c = (_d.sent()).url;
                return [3, 3];
            case 2:
                _c = undefined;
                _d.label = 3;
            case 3:
                _b.backgroundImageUrl = _c;
                headingElement = newAccordion.children[0].children[0];
                headingElement.children.splice(1);
                headingTextNode = headingElement.children[0];
                headingTextNode.text = "";
                headingTextNode.marks = headingTextNode.marks.filter(function (mark) { return mark.type !== EditorTypes_1.MarkType.Comment; });
                newAccordion.children[1].children = [(0, Paragraph_1.createParagraphNode)()];
                newAccordionPath = slate_1.Path.next(existingAccordionPath);
                newAccordionHeadingPath = __spreadArray(__spreadArray([], __read(newAccordionPath), false), [0, 0], false);
                slate_1.Transforms.insertNodes(editor, newAccordion, { at: newAccordionPath });
                slate_1.Transforms.select(editor, newAccordionHeadingPath);
                slate_react_1.ReactEditor.focus(editor);
                return [2];
        }
    });
}); };
exports.quickCreateAccordion = quickCreateAccordion;
var expandAccordionIfCollapsed = function (editor) {
    var anchor = editor.selection.anchor;
    var _a = __read((0, Utils_1.checkAncestors)(editor, anchor.path, accordionMatcher), 2), accordionPath = _a[1];
    var accordionWidget = (0, Utils_2.as)("accordion", slate_1.Node.descendant(editor, accordionPath));
    if (!accordionWidget.data.expanded) {
        var nextData = (0, lodash_1.cloneDeep)(accordionWidget.data);
        nextData.expanded = true;
        slate_1.Transforms.setNodes(editor, { data: nextData }, { at: accordionPath });
        return true;
    }
};
exports.expandAccordionIfCollapsed = expandAccordionIfCollapsed;
var pickBackgroundImage = function (di, editor, accordionPath) { return __awaiter(void 0, void 0, Promise, function () {
    var pickerResult, url, accordionWidget, nextData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, di.invoke(ShowImagePicker_1.default)()];
            case 1:
                pickerResult = _a.sent();
                url = pickerResult.url;
                if (!pickerResult.uploadId) return [3, 3];
                return [4, di.get("uploadStore").waitForUpload(pickerResult.uploadId)];
            case 2:
                url = (_a.sent()).url;
                _a.label = 3;
            case 3:
                accordionWidget = (0, Utils_2.as)("accordion", slate_1.Node.descendant(editor, accordionPath));
                nextData = (0, lodash_1.cloneDeep)(accordionWidget.data);
                nextData.backgroundImageUrl = url;
                slate_1.Transforms.setNodes(editor, { data: nextData }, { at: accordionPath });
                di.get("editorTelemetry").accordionChangedBackgroundImage();
                return [2, true];
        }
    });
}); };
exports.pickBackgroundImage = pickBackgroundImage;
var ensureVisualAccordionImages = function (editor, stockImagesService) { return __awaiter(void 0, void 0, Promise, function () {
    var accordionNodes, accordionNodes_1, accordionNodes_1_1, _a, accordionNode, accordionPath, data, image, nextData, e_1_1;
    var e_1, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                accordionNodes = Array.from(slate_1.Editor.nodes(editor, { at: [], match: accordionMatcher }));
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, 7, 8]);
                accordionNodes_1 = __values(accordionNodes), accordionNodes_1_1 = accordionNodes_1.next();
                _c.label = 2;
            case 2:
                if (!!accordionNodes_1_1.done) return [3, 5];
                _a = __read(accordionNodes_1_1.value, 2), accordionNode = _a[0], accordionPath = _a[1];
                data = (0, Utils_2.as)("accordion", accordionNode).data;
                if (!!data.backgroundImageUrl) return [3, 4];
                return [4, stockImagesService.getRandomImage({ preventBoringImages: true })];
            case 3:
                image = _c.sent();
                nextData = (0, lodash_1.cloneDeep)(data);
                nextData.backgroundImageUrl = image.url;
                slate_1.Transforms.setNodes(editor, { data: nextData }, { at: accordionPath });
                _c.label = 4;
            case 4:
                accordionNodes_1_1 = accordionNodes_1.next();
                return [3, 2];
            case 5: return [3, 8];
            case 6:
                e_1_1 = _c.sent();
                e_1 = { error: e_1_1 };
                return [3, 8];
            case 7:
                try {
                    if (accordionNodes_1_1 && !accordionNodes_1_1.done && (_b = accordionNodes_1.return)) _b.call(accordionNodes_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7];
            case 8: return [2];
        }
    });
}); };
exports.ensureVisualAccordionImages = ensureVisualAccordionImages;
var maybeBackspaceIntoHeading = function (editor) {
    var selection = editor.selection;
    var previousPoint = slate_1.Editor.before(editor, selection.anchor);
    if (!previousPoint) {
        return;
    }
    var previousAccordion = (0, Utils_1.checkAncestors)(editor, previousPoint.path, accordionMatcher);
    if (!previousAccordion) {
        return;
    }
    var accordionNode = (0, Utils_2.as)("accordion", previousAccordion[0]);
    var isAccordionExpanded = accordionNode.data.expanded;
    if (isAccordionExpanded) {
        return;
    }
    var _a = __read((0, Utils_1.getClosestBlock)(editor, selection.anchor.path), 2), nodeToMove = _a[0], pathToMove = _a[1];
    slate_1.Transforms.removeNodes(editor, { at: pathToMove });
    var endOfAccordionHeading = slate_1.Range.end(slate_1.Editor.range(editor, __spreadArray(__spreadArray([], __read(previousAccordion[1]), false), [0], false)));
    slate_1.Transforms.select(editor, endOfAccordionHeading);
    (0, PasteActions_1.insertAndAssume)(editor, [nodeToMove]);
    slate_1.Transforms.select(editor, endOfAccordionHeading);
    return true;
};
exports.maybeBackspaceIntoHeading = maybeBackspaceIntoHeading;
var moveFocusAndToggle = function (editor, from, direction) {
    var _a;
    var _b = __read((0, Utils_1.checkAncestors)(editor, editor.selection.anchor.path, accordionMatcher), 2), accordionNode = _b[0], accordionPath = _b[1];
    var accordion = (0, Utils_2.as)("accordion", accordionNode);
    var indexes = (_a = {}, _a["accordionHeading"] = 0, _a["accordionBody"] = 1, _a);
    var originalIndex = indexes[from];
    var newIndex = originalIndex + (direction === "forward" ? 1 : -1);
    if (newIndex >= 0 && newIndex <= 1) {
        var newTargetNodeRange = slate_1.Editor.range(editor, __spreadArray(__spreadArray([], __read(accordionPath), false), [newIndex], false));
        var newFocus = direction === "forward" ? newTargetNodeRange.anchor : newTargetNodeRange.focus;
        slate_1.Transforms.select(editor, newFocus);
        var newExpandedState = direction === "forward";
        slate_1.Transforms.setNodes(editor, { data: __assign(__assign({}, (0, lodash_1.cloneDeep)(accordion.data)), { expanded: newExpandedState }) }, { at: accordionPath });
    }
    else if (newIndex === -1) {
        var previous = slate_1.Editor.end(editor, slate_1.Editor.previous(editor, { at: accordionPath, mode: "highest" })[1]);
        slate_1.Transforms.select(editor, previous);
    }
    else if (newIndex === 2) {
        var next = slate_1.Editor.start(editor, slate_1.Editor.next(editor, { at: accordionPath, mode: "highest" })[1]);
        slate_1.Transforms.select(editor, next);
    }
};
exports.moveFocusAndToggle = moveFocusAndToggle;
var accordionMatcher = function (curr) {
    return slate_1.Element.isElement(curr) && curr.type === "accordion";
};
exports.accordionMatcher = accordionMatcher;
var isVisualAccordion = function (blockStyleStore) {
    var accordionStyles = blockStyleStore.getElementStyle("accordion");
    return accordionStyles.cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Visual;
};
